import Content from "components/Content";
import Label from "components/Label";
import Head from "next/head";
import HummingFooter from "pages/components/HummingFooter";
import HummingNav from "pages/components/HummingNav";
import React from "react";
import { ExtendedNextPage } from "types/pages";
import styles from "./styles.module.scss";

const Calendar: ExtendedNextPage = () => {
  return (
    <div className={styles.container}>
      <Head>
        <title>Calendar</title>
        <meta name="description" content="Humming home's calendar" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Content
        containerClassName={styles.contentWrapper}
        contentClassName={styles.content}
      >
        <Label className={styles.title} variant="h2-centered" color="white">
          Chat with our Membership Director
        </Label>
        <Label className={styles.subtitle} variant="s3-centered" color="white">
          Feel free to book time to speak with our membership director, so we
          can support taking home maintenance off your plate. During your call,
          you&apos;ll discuss: your home&apos;s current needs, improvements to
          be made, and proactive and streamlined seasonal maintenance
        </Label>
        <div
          className="meetings-iframe-container"
          data-src="https://meetings.hubspot.com/hello-at?embed=true"
        />
      </Content>
    </div>
  );
};

Calendar.getLayout = (page) => {
  return (
    <div>
      <HummingNav />
      {page}
      <HummingFooter />
    </div>
  );
};

export default Calendar;
